import { Locale } from 'chaika-enums';
export const dashboardModule = {
    selectDoctorText: {
        [Locale.Ru]: `Выберите докторов, с которыми работаете`,
        [Locale.Am]: `Ընտրեք բժիշկներին, որոնց հետ աշխատում եք`,
        [Locale.En]: `Select the doctors you work with`,
        [Locale.Pt]: `Selecione os médicos com quem você trabalha`,
        [Locale.Ge]: `Select the doctors you work with`,
    },
    searchByDoctorFullName: {
        [Locale.Ru]: `Поиск по фио доктора`,
        [Locale.Am]: `Որոնում ըստ բժշկի անվան, ազգանվան, հայրանվան`,
        [Locale.En]: `Search by doctor's full name`,
        [Locale.Pt]: 'Pesquisar pelo nome completo do médico',
        [Locale.Ge]: `Search by doctor's full name`,
    },
    activeReferralFilters: {
        [Locale.Ru]: `Фильтры для активных направлений`,
        [Locale.Am]: `Զտիչներ ակտիվ ուղեգրերի համար`,
        [Locale.En]: `Filters for active referrals`,
        [Locale.Pt]: 'Filtros para referências ativas',
        [Locale.Ge]: `Filters for active referrals`,
    },
    searchByLoincOrVendorCode: {
        [Locale.Ru]: `Поиск по loinc или артикулу`,
        [Locale.Am]: `Որոնում ըստ loinc-ի կամ արտիկուլի`,
        [Locale.En]: `Search by loinc or vendor code`,
        [Locale.Pt]: `Pesquisar por loinc ou código do fornecedor`,
        [Locale.Ge]: `Search by loinc or vendor code`,
    },
    referralName: {
        [Locale.Ru]: `Название направления`,
        [Locale.Am]: `Ուղեգրի անվանում`,
        [Locale.En]: `Name of the referral`,
        [Locale.Pt]: `Nome da indicação`,
        [Locale.Ge]: `Name of the referral`,
    },
    noTasks: {
        [Locale.Ru]: `Без заданий`,
        [Locale.Am]: `Առանց առաջադրանքների`,
        [Locale.En]: `No tasks`,
        [Locale.Pt]: `Sem tarefas`,
        [Locale.Ge]: `No tasks`,
    },
    overdueTasks: {
        [Locale.Ru]: `Просроченные задания`,
        [Locale.Am]: `Ժամկետանց առաջադրանքներ`,
        [Locale.En]: `Overdue tasks`,
        [Locale.Pt]: `Tarefas atrasadas`,
        [Locale.Ge]: `Overdue tasks`,
    },
    attached: {
        [Locale.Ru]: `Прикреплена`,
        [Locale.Am]: `Կցված է`,
        [Locale.En]: `Attached`,
        [Locale.Pt]: `Anexado`,
        [Locale.Ge]: `Attached`,
    },
    notAttached: {
        [Locale.Ru]: `Не прикреплена`,
        [Locale.Am]: `Կցված չէ`,
        [Locale.En]: `Not attached`,
        [Locale.Pt]: `Não anexado`,
        [Locale.Ge]: `Not attached`,
    },
    firstMonthPaymentText: {
        [Locale.Ru]: `Списание платежа за первый месяц произойдет сразу после добавления подписки`,
        [Locale.Am]: `Առաջին ամսվա վճարի դուրսգրումը տեղի կունենա բաժանորդագրությունն ավելացնելուց անմիջապես հետո`,
        [Locale.En]: `Payment for the first month will be debited immediately after adding a subscription.`,
        [Locale.Pt]: `O pagamento do primeiro mês será debitado imediatamente após a adição de uma assinatura.`,
        [Locale.Ge]: `Payment for the first month will be debited immediately after adding a subscription.`,
    },
    subscriptionInvoiceText: {
        [Locale.Ru]: `Счёт за подписку будет выставлен после добавления подписки и отобразится в неоплаченных счетах`,
        [Locale.Am]: `Բաժանորդագրության հաշիվը կդուրս գրվի բաժանորդագրությունն ավելացնելուց հետո և կցուցադրվի չվճարված հաշիվներում`,
        [Locale.En]: `The subscription invoice will be issued after adding the subscription and will appear in the unpaid invoices.`,
        [Locale.Pt]: `A fatura da assinatura será emitida após a adição da assinatura e aparecerá nas faturas não pagas.`,
        [Locale.Ge]: `The subscription invoice will be issued after adding the subscription and will appear in the unpaid invoices.`,
    },
    selectEhrFirst: {
        [Locale.Ru]: `Сначала выберите пациента`,
        [Locale.Am]: `Նախ ընտրեք պացիենտին`,
        [Locale.En]: `First select the patient`,
        [Locale.Pt]: `Primeiro selecione o paciente`,
        [Locale.Ge]: `First select the patient`,
    },
    legalRepresentatives: {
        [Locale.Ru]: `Законные представители пациента`,
        [Locale.Am]: `Պացիենտի օրինական ներկայացուցիչները`,
        [Locale.En]: `Legal representatives of the patient`,
        [Locale.Pt]: `Representantes legais do paciente`,
        [Locale.Ge]: `Legal representatives of the patient`,
    },
    subscriptionOptions: {
        [Locale.Ru]: `Параметры подписки`,
        [Locale.Am]: `Բաժանորդագրության պարամետրեր`,
        [Locale.En]: `Subscription Options`,
        [Locale.Pt]: `Opções de Assinatura`,
        [Locale.Ge]: `Subscription Options`,
    },
    periodAndCost: {
        [Locale.Ru]: `Срок действия и стоимость`,
        [Locale.Am]: `Գործողության ժամկետ և արժեք`,
        [Locale.En]: `Validity period and cost`,
        [Locale.Pt]: `Período de validade e custo`,
        [Locale.Ge]: `Validity period and cost`,
    },
    monthlyRenewal: {
        [Locale.Ru]: `Ежемесячное продление.`,
        [Locale.Am]: `Ամսական երկարաձգում։`,
        [Locale.En]: `Monthly renewal.`,
        [Locale.Pt]: `Renovação mensal.`,
        [Locale.Ge]: `Monthly renewal.`,
    },
    additionalInfoText: {
        [Locale.Ru]: `Дополнительная информация или договоренности с пациентом`,
        [Locale.Am]: `Լրացուցիչ տեղեկություն կամ պայմանավորվածություններ պացիենտի հետ`,
        [Locale.En]: `Additional information or agreements with the patient`,
        [Locale.Pt]: `Informações adicionais ou acordos com o paciente`,
        [Locale.Ge]: `Additional information or agreements with the patient`,
    },
    subscriptionNotPaidText: {
        [Locale.Ru]: `Подписка не была оплачена, поэтому при отмене она сразу попадет в архивные`,
        [Locale.Am]: `Բաժանորդագրությունը չի վճարվել, ուստի չեղարկելիս այն անմիջապես կտեղափոխվի արխիվայիններ`,
        [Locale.En]: `The subscription has not been paid for, so if you cancel it, it will immediately go to the archives`,
        [Locale.Pt]: `A assinatura não foi paga, portanto, se você a cancelar, ela irá imediatamente para os arquivos`,
        [Locale.Ge]: `The subscription has not been paid for, so if you cancel it, it will immediately go to the archives`,
    },
    subscriptionIfCancelText: {
        [Locale.Ru]: `При отмене подписки она будет доступна до`,
        [Locale.Am]: `Բաժանորդագրությունը չեղարկելիս այն հասանելի կլինի մինչև`,
        [Locale.En]: `If you cancel your subscription, it will be available until`,
        [Locale.Pt]: `Se você cancelar sua assinatura, ela estará disponível até`,
        [Locale.Ge]: `If you cancel your subscription, it will be available until`,
    },
    afterAccessTerminated: {
        [Locale.Ru]: `после этого доступ прекратится`,
        [Locale.Am]: `դրանից հետո հասանելիությունը կդադարի`,
        [Locale.En]: `after this, access will be terminated`,
        [Locale.Pt]: `depois disso, o acesso será encerrado`,
        [Locale.Ge]: `after this, access will be terminated`,
    },
    cancelSubscription: {
        [Locale.Ru]: `Отменить подписку`,
        [Locale.Am]: `Չեղարկել բաժանորդագրությունը`,
        [Locale.En]: `Cancel subscription`,
        [Locale.Pt]: `Cancelar assinatura`,
        [Locale.Ge]: `Cancel subscription`,
    },
    subscriptionWillActiveUntil: {
        [Locale.Ru]: `Подписка будет доступна до`,
        [Locale.Am]: `Բաժանորդագրությունը հասանելի կլինի մինչև`,
        [Locale.En]: `The subscription will be available until`,
        [Locale.Pt]: `A assinatura estará disponível até`,
        [Locale.Ge]: `The subscription will be available until`,
    },
    afterGoToArchive: {
        [Locale.Ru]: `после этого попадет в архив`,
        [Locale.Am]: `դրանից հետո կտեղափոխվի արխիվ`,
        [Locale.En]: `after that it will go into the archive`,
        [Locale.Pt]: `depois disso, ela irá para o arquivo`,
        [Locale.Ge]: `after that it will go into the archive`,
    },
    returnExtension: {
        [Locale.Ru]: `Вернуть продление`,
        [Locale.Am]: `Վերականգնել երկարաձգումը`,
        [Locale.En]: `Return extension`,
        [Locale.Pt]: `Retornar extensão`,
        [Locale.Ge]: `Return extension`,
    },
    billedWillAutomaticallyText: {
        [Locale.Ru]: `Счёт за подписку будет выставлен пациенту автоматически`,
        [Locale.Am]: `Բաժանորդագրության հաշիվը պացիենտին կդուրս գրվի ավտոմատ`,
        [Locale.En]: `The subscription fee will be billed to the patient automatically.`,
        [Locale.Pt]: `A taxa de assinatura será cobrada do paciente automaticamente.`,
        [Locale.Ge]: `The subscription fee will be billed to the patient automatically.`,
    },
    renewSubscription: {
        [Locale.Ru]: `Возобновить подписку`,
        [Locale.Am]: `Վերսկսել բաժանորդագրությունը`,
        [Locale.En]: `Renew subscription`,
        [Locale.Pt]: `Renovar assinatura`,
        [Locale.Ge]: `Renew subscription`,
    },
    patientServices: {
        [Locale.Ru]: `Услуги пациента`,
        [Locale.Am]: `Պացիենտի ծառայությունները`,
        [Locale.En]: `Patient services`,
        [Locale.Pt]: `Serviços do paciente`,
        [Locale.Ge]: `Patient services`,
    },
    totalServices: {
        [Locale.Ru]: `Всего услуг`,
        [Locale.Am]: `Ընդամենը ծառայություններ`,
        [Locale.En]: `Total services`,
        [Locale.Pt]: `Total de serviços`,
        [Locale.Ge]: `Total services`,
    },
    totalPaid: {
        [Locale.Ru]: `Всего к оплате`,
        [Locale.Am]: `Ընդամենը վճարման ենթակա`,
        [Locale.En]: `Total to be paid`,
        [Locale.Pt]: `Total a pagar`,
        [Locale.Ge]: `Total to be paid`,
    },
    potentialWithdrawals: {
        [Locale.Ru]: `Потенциальные снятия`,
        [Locale.Am]: `Հնարավոր դուրսգրումներ`,
        [Locale.En]: `Potential withdrawals`,
        [Locale.Pt]: `Retiradas potenciais`,
        [Locale.Ge]: `Potential withdrawals`,
    },
    entryWithoutRS: {
        [Locale.Ru]: `Записи без оказанных услуг`,
        [Locale.Am]: `Գրառումներ առանց մատուցված ծառայությունների`,
        [Locale.En]: `Entries without services rendered`,
        [Locale.Pt]: `Entradas sem serviços prestados`,
        [Locale.Ge]: `Entries without services rendered`,
    },
    totalRecords: {
        [Locale.Ru]: `Всего записей`,
        [Locale.Am]: `Ընդամենը գրառումներ`,
        [Locale.En]: `Total records`,
        [Locale.Pt]: `Registros totais`,
        [Locale.Ge]: `Total records`,
    },
    myUnpaidServices: {
        [Locale.Ru]: `Мои неоплаченные услуги`,
        [Locale.Am]: `Իմ չվճարված ծառայությունները`,
        [Locale.En]: `My unpaid services`,
        [Locale.Pt]: `Meus serviços não pagos`,
        [Locale.Ge]: `My unpaid services`,
    },
    unpaidServiceByReferral: {
        [Locale.Ru]: `Мои неоплаченные услуги по направлениям`,
        [Locale.Am]: `Իմ չվճարված ծառայություններն ըստ ուղեգրերի`,
        [Locale.En]: `My unpaid services by referrals`,
        [Locale.Pt]: `Meus serviços não pagos por indicações`,
        [Locale.Ge]: `My unpaid services by referrals`,
    },
    myEntriesWithoutESD: {
        [Locale.Ru]: `Мои не подписанные ЭЦП записи`,
        [Locale.Am]: `Իմ՝ էլեկտրոնային ստորագրությամբ չստորագրված գրառումները`,
        [Locale.En]: `My entries not signed with digital signature`,
        [Locale.Pt]: `Minhas entradas não assinadas com assinatura digital`,
        [Locale.Ge]: `My entries not signed with digital signature`,
    },
    myUnpublishedEntries: {
        [Locale.Ru]: `Мои не опубликованные записи`,
        [Locale.Am]: `Իմ չհրապարակված գրառումները`,
        [Locale.En]: `My unpublished entries`,
        [Locale.Pt]: `Minhas entradas não publicadas`,
        [Locale.Ge]: `My unpublished entries`,
    },
    selectDoctors: {
        [Locale.Ru]: `Выберите докторов`,
        [Locale.Am]: `Ընտրեք բժիշկներին`,
        [Locale.En]: `Select doctors`,
        [Locale.Pt]: `Selecionar médicos`,
        [Locale.Ge]: `Select doctors`,
    },
    withWhomText: {
        [Locale.Ru]: `с которыми работаете, чтобы увидеть направления, визиты и задания`,
        [Locale.Am]: `որոնց հետ աշխատում եք՝ ուղեգրերը, այցերը և առաջադրանքները տեսնելու համար`,
        [Locale.En]: `with whom you work to see directions, visits and tasks`,
        [Locale.Pt]: `com quem você trabalha para ver orientações, visitas e tarefas`,
        [Locale.Ge]: `with whom you work to see directions, visits and tasks`,
    },
    bankCard: {
        [Locale.Ru]: `банковская карта`,
        [Locale.Am]: `բանկային քարտ`,
        [Locale.En]: `bank card`,
        [Locale.Pt]: `cartão bancário`,
        [Locale.Ge]: `band card`,
    },
    mainDoctor: {
        [Locale.Ru]: `Основной доктор`,
        [Locale.Am]: `Հիմնական բժիշկ`,
        [Locale.En]: `Main doctor`,
        [Locale.Pt]: `Médico Primário`,
        [Locale.Ge]: `Main doctor`,
    },
    addSubscription: {
        [Locale.Ru]: `Добавить подписку`,
        [Locale.Am]: `Ավելացնել բաժանորդագրություն`,
        [Locale.En]: `Add subscription`,
        [Locale.Pt]: `Adicionar assinatura`,
        [Locale.Ge]: `Add subscription`,
    },
    youHave: {
        [Locale.Ru]: `У вас`,
        [Locale.Am]: `Դուք ունեք`,
        [Locale.En]: `You have`,
        [Locale.Pt]: `Você tem`,
        [Locale.Ge]: `You have`,
    },
    paidUpTo: {
        [Locale.Ru]: `Оплачена до`,
        [Locale.Am]: `Վճարված է մինչև`,
        [Locale.En]: `Paid up to`,
        [Locale.Pt]: `Pago até`,
        [Locale.Ge]: `Paid up to`,
    },
    notPaidHasInvoice: {
        [Locale.Ru]: `Не оплачено, выставлен счет`,
        [Locale.Am]: `Չվճարված է, հաշիվը դուրս է գրված`,
        [Locale.En]: `Not paid, invoice issued`,
        [Locale.Pt]: `Não pago, fatura emitida`,
        [Locale.Ge]: `Not paid, invoice issued`,
    },
    editingSubscription: {
        [Locale.Ru]: `Редактирование подписки`,
        [Locale.Am]: `Բաժանորդագրության խմբագրում`,
        [Locale.En]: `Editing a subscription`,
        [Locale.Pt]: `Editando uma assinatura`,
        [Locale.Ge]: `Editing a subscription`,
    },
    newSubscription: {
        [Locale.Ru]: `Новая подписка`,
        [Locale.Am]: `Նոր բաժանորդագրություն`,
        [Locale.En]: `New subscription`,
        [Locale.Pt]: `Nova assinatura`,
        [Locale.Ge]: `New subscription`,
    },
    currentSubscription: {
        [Locale.Ru]: `Действующая подписка`,
        [Locale.Am]: `Գործող բաժանորդագրություն`,
        [Locale.En]: `Current subscription`,
        [Locale.Pt]: `Assinatura atual`,
        [Locale.Ge]: `Current subscription`,
    },
    trialSubscription: {
        [Locale.Ru]: `Подписка с пробным периодом`,
        [Locale.Am]: `Բաժանորդագրություն փորձնական ժամանակահատվածով`,
        [Locale.En]: `Trial subscription`,
        [Locale.Pt]: `Assinatura de teste`,
        [Locale.Ge]: `Trial subscription`,
    },
    trialSubscriptionShort: {
        [Locale.Ru]: 'Пробная подписка',
        [Locale.Am]: 'Փորձնական բաժանորդագրություն',
        [Locale.En]: `Trial subscription`,
        [Locale.Pt]: `Assinatura de teste`,
        [Locale.Ge]: `Trial subscription`,
    },
    expiredSubscription: {
        [Locale.Ru]: `Истекшая подписка`,
        [Locale.Am]: `Ժամկետանց բաժանորդագրություն`,
        [Locale.En]: `Expired subscription`,
        [Locale.Pt]: `Assinatura expirada`,
        [Locale.Ge]: `Expired subscription`,
    },
    upcomingPayment: {
        [Locale.Ru]: `Предстоящая оплата`,
        [Locale.Am]: `Առաջիկա վճարում`,
        [Locale.En]: `Upcoming payment`,
        [Locale.Pt]: `Próximo pagamento`,
        [Locale.Ge]: `Upcoming payment`,
    },
    notDiagnosisInServiceText: {
        [Locale.Ru]: `в услуге не указан диагноз`,
        [Locale.Am]: `ծառայության մեջ նշված չէ ախտորոշում`,
        [Locale.En]: `the service does not indicate a diagnosis`,
        [Locale.Pt]: `o serviço não indica um diagnóstico`,
        [Locale.Ge]: `the service does not indicate a diagnosis`,
    },
    noPolicyInAttachmentText: {
        [Locale.Ru]: `в прикреплении отсутствует номер полиса`,
        [Locale.Am]: `կցման մեջ բացակայում է պոլիսի համարը`,
        [Locale.En]: `there is no policy number in the attachment`,
        [Locale.Pt]: `não há número de apólice no anexo`,
        [Locale.Ge]: `there is no policy number in the attachment`,
    },
    notToothNumberText: {
        [Locale.Ru]: `в записи отсутствует номер зуба`,
        [Locale.Am]: `գրառման մեջ բացակայում է ատամի համարը`,
        [Locale.En]: `the tooth number is missing from the record`,
        [Locale.Pt]: `o número do dente está faltando no registro`,
        [Locale.Ge]: `the tooth number is missing from the record`,
    },
    entryDataTime: {
        [Locale.Ru]: `Дата и время записи`,
        [Locale.Am]: `Գրառման ամսաթիվ և ժամ`,
        [Locale.En]: `Date and time of recording`,
        [Locale.Pt]: `Data e hora da gravação`,
        [Locale.Ge]: `Date and time of recording`,
    },
    reasonForRemoval: {
        [Locale.Ru]: `Причина снятия`,
        [Locale.Am]: `Դուրսգրման պատճառ`,
        [Locale.En]: `Reason for removal`,
        [Locale.Pt]: `Motivo da remoção`,
        [Locale.Ge]: `Reason for removal`,
    },
    covered: {
        [Locale.Ru]: `Покрыто`,
        [Locale.Am]: `Ծածկված է`,
        [Locale.En]: `Covered`,
        [Locale.Pt]: `Coberto`,
        [Locale.Ge]: `Covered`,
    },
    entryWithService: {
        [Locale.Ru]: `Запись с услугой`,
        [Locale.Am]: `Գրառում ծառայությամբ`,
        [Locale.En]: `Entry with service`,
        [Locale.Pt]: `Entrada com serviço`,
        [Locale.Ge]: `Entry with service`,
    },
    entryWithReferral: {
        [Locale.Ru]: `Запись с направлением`,
        [Locale.Am]: `Գրառում ուղեգրով`,
        [Locale.En]: `Entry with referral`,
        [Locale.Pt]: `Entrada com indicação`,
        [Locale.Ge]: `Entry with referral`,
    },
    hideExpired: {
        [Locale.Ru]: `Скрыть просроченные`,
        [Locale.Am]: `Թաքցնել ժամկետանցները`,
        [Locale.En]: `Hide expired`,
        [Locale.Pt]: `Ocultar expirado`,
        [Locale.Ge]: `Hide expired`,
    },
    hideCompletedTasks: {
        [Locale.Ru]: `Скрыть выполненные задания`,
        [Locale.Am]: `Թաքցնել կատարված առաջադրանքները`,
        [Locale.En]: `Hide completed tasks`,
        [Locale.Pt]: `Ocultar tarefas concluídas`,
        [Locale.Ge]: `Hide completed tasks`,
    },
    hideDeletedTasks: {
        [Locale.Ru]: `Скрыть удаленные задания`,
        [Locale.Am]: `Թաքցնել ջնջված առաջադրանքները`,
        [Locale.En]: `Hide deleted tasks`,
        [Locale.Pt]: `Ocultar tarefas excluídas`,
        [Locale.Ge]: `Hide deleted tasks`,
    },
    indicator: {
        [Locale.Ru]: `Индикатор`,
        [Locale.Am]: `Ինդիկատոր`,
        [Locale.En]: `Indicator`,
        [Locale.Pt]: `Indicador`,
        [Locale.Ge]: `Indicator`,
    },
    noFollowUp: {
        [Locale.Ru]: `Без фоллоу-ап`,
        [Locale.Am]: `Առանց follow-up-ի`,
        [Locale.En]: `No follow-Up`,
        [Locale.Pt]: `Sem acompanhamento`,
        [Locale.Ge]: `No follow-Up`,
    },
    entryLink: {
        [Locale.Ru]: `Ссылка на запись`,
        [Locale.Am]: `Գրառման հղում`,
        [Locale.En]: `Entry link`,
        [Locale.Pt]: 'Link de entrada',
        [Locale.Ge]: `Entry link`,
    },
    unpaidMultiple: {
        [Locale.Ru]: `Неоплаченные`,
        [Locale.Am]: `Չվճարվածներ`,
        [Locale.En]: `Unpaid`,
        [Locale.Pt]: `Não pago`,
        [Locale.Ge]: `Unpaid`,
    },
    selectManagerToSeeEpisodes: {
        [Locale.Ru]: `Выберите менеджера, чтобы увидеть эпизоды`,
        [Locale.Am]: `Ընտրեք մենեջերին՝ էպիզոդները տեսնելու համար`,
        [Locale.En]: `Select a manager to see episodes`,
        [Locale.Pt]: `Selecione um gestor para ver os episódios`,
        [Locale.Ge]: `Select a manager to see episodes`,
    },
    selectDoctorOrAuthorToSeeEntries: {
        [Locale.Ru]: `Выберите доктора или автора, чтобы увидеть записи`,
        [Locale.Am]: `Ընտրեք բժշկին կամ հեղինակին՝ գրառումները տեսնելու համար`,
        [Locale.En]: `Select a doctor or author to see entries`,
        [Locale.Pt]: `Selecione um médico ou autor para ver os registros`,
        [Locale.Ge]: `Select a doctor or author to see entries`,
    },
    selectReferrerOrAuthorToSeeReferrals: {
        [Locale.Ru]: `Выберите «Кто направил» или «Автора», чтобы увидеть направления`,
        [Locale.Am]: `Ընտրեք «Ով է ուղեգրել» կամ «Հեղինակ»՝ ուղեգրերը տեսնելու համար`,
        [Locale.En]: `Select "Referred by" or "Author" to see referrals`,
        [Locale.Pt]: `Selecione "Quem encaminhou" ou "Autor" para ver os encaminhamentos`,
        [Locale.Ge]: `Select "Referred by" or "Author" to see referrals`,
    },
    selectAuthorToSeeOutwardReferrals: {
        [Locale.Ru]: `Выберите автора, чтобы увидеть внешние направления`,
        [Locale.Am]: `Ընտրեք հեղինակին՝ արտաքին ուղեգրերը տեսնելու համար`,
        [Locale.En]: `Select an author to see outward referrals`,
        [Locale.Pt]: `Selecione um autor para ver os encaminhamentos externos`,
        [Locale.Ge]: `Select an author to see outward referrals`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
